// src/app/material-form/material-form.component.ts
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Materials } from '../../../Materials';
import { MaterialsService } from '../Services/materials.service';

@Component({
  selector: 'app-material-form',
  templateUrl: './material-form.component.html',
  styleUrls: ['./material-form.component.css'],
})
export class MaterialFormComponent implements OnInit {
  material: Materials = {
    id: 0,
    materialsID: 0,
    productCategory: '',
    subCategory: '',
    productName: '',
    productDescription: '',
    productPrice: 0,
    productWeight: 0,
    units: '',
    total: 0,
  };

  constructor(
    private route: ActivatedRoute,private router: Router, private materialsService: MaterialsService
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const materialId = parseInt(params.get('id') || '0', 10);
      if (materialId > 0) {
        this.loadMaterial(materialId);
      }
    });
  }

  loadMaterial(materialId: number) {
    this.materialsService.getMaterial(materialId).subscribe((material) => {
      this.material = material;
    });
  }

  saveMaterial() { 
    if (this.material.id > 0) {
      this.material.productPrice = +this.material.productPrice;
      this.materialsService.editMaterial(this.material).subscribe(() => {
        console.log('Material updated successfully!');
        this.router.navigate(['materials']);

      });
    } else {
      
      this.material.productPrice = +this.material.productPrice;
      this.materialsService.addMaterial(this.material).subscribe(() => {
         
        console.log('Material added successfully!');
        this.router.navigate(['materials']);
      });
    }
  }
}
